import { http } from "@/services/http";
import type { ReportsDTO } from "@/models/dtos/reports-dto";
import { authService } from "@/services/auth-service";

class ReportService {
  async getReport(reportId: string | number) {
    const authHeader = await authService.getAuthHeader();
    return http
      .url(`/reports/${reportId}`)
      .auth(authHeader)
      .get()
      .json<ReportsDTO>();
  }
}

export const reportService = new ReportService();
